function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M796.59,471.67a29.89,29.89,0,1,1-29.9,29.89,29.87,29.87,0,0,1,29.9-29.89m0,118.4a88.4,88.4,0,0,0,83.37-59h182.17v-59H880a88.39,88.39,0,0,0-166.74,0H0v59H713.22a88.42,88.42,0,0,0,83.37,59"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M531.47,295a29.83,29.83,0,1,1-29.9,29.9,29.89,29.89,0,0,1,29.9-29.9m-.4,118a88.39,88.39,0,0,0,83.36-59H944.12V295H614.43a88.4,88.4,0,0,0-166.73,0H193a117.74,117.74,0,0,1,162-42.62C354.44,247,354,241.53,354,236a174.54,174.54,0,0,1,6.43-46.42,176.74,176.74,0,0,1,331.09-27.93l46.69-38.95A236.07,236.07,0,0,0,531.07,0c-110,0-202.2,75.4-228.44,177.42-2.48-.13-5-.4-7.59-.4-77,0-142.4,49.3-166.66,118A176.26,176.26,0,0,0,118,354H447.7a88.41,88.41,0,0,0,83.37,59"
});

var SvgClimadjustIsBlack = function SvgClimadjustIsBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 1062.13 590.07",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClimadjustIsBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Climadjust_IS-BLACK.39d4fbb0.svg";
export { ForwardRef as ReactComponent };